__turbopack_context__.v({
  "period": "aWSH1a_period",
  "totals": "aWSH1a_totals",
});
